import { render, staticRenderFns } from "./CertificationDownloaderModal.vue?vue&type=template&id=68474136&scoped=true&"
import script from "./CertificationDownloaderModal.vue?vue&type=script&lang=js&"
export * from "./CertificationDownloaderModal.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDownloaderModal.vue?vue&type=style&index=0&id=68474136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68474136",
  null
  
)

export default component.exports